import { api } from '../../http';
import { FieldFilling } from '../../types/interfaces';

import Api from './api';
import IFieldFillingControlsApi from './interfaces/fieldFillingControlsApi';

class FieldFillingControlsApi
  extends Api<FieldFilling>
  implements IFieldFillingControlsApi
{
  constructor(abortController: AbortController) {
    super('fieldFillingControl/', abortController);
  }
  async getByStatusTransition(id: number) {
    const apiCallResult = await api.get<FieldFilling[]>(
      `fieldFillingControl/getByStatusTransition/${id}`,
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
  async saveListForStatusTransition(list: FieldFilling[]) {
    const apiCallResult = await api.post(
      'fieldFillingControl/saveListForStatusTransition',
      list,
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default FieldFillingControlsApi;
